import React from "react"
import PropTypes from "prop-types"
import AstrositeName from "./AstrositeName"

const AstrositeMapLabel = ({ astrosite = {} }) => {
  return (
    <div>
      <AstrositeName astrositeId={astrosite.id} />
      {astrosite.location && astrosite.location.latitude_degrees && (
        <div>Latitude: {astrosite.location.latitude_degrees}</div>
      )}
      {astrosite.location && astrosite.location.longitude_degrees && (
        <div>Longitude: {astrosite.location.longitude_degrees}</div>
      )}
      {astrosite.location && astrosite.location.height_metres && (
        <div>Height: {astrosite.location.height_metres}</div>
      )}
    </div>
  )
}

AstrositeMapLabel.propTypes = {
  astrosite: PropTypes.object.isRequired, // details about the astrosite
}

export default AstrositeMapLabel
